<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <app-title text="Página de Soporte"></app-title>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <router-view></router-view>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import TicketForm from './TicketForm';
export default {
    components: {
        appTicketForm: TicketForm
    }
}
</script>